<!-- Modal -->
<div  id="login">
    <div class="modal-content" >
        <div class="modal-header border-0">
            <h3 class="modal-title text-center m-auto" id="loginLabel" style="color:#00008b">Iniciar Sesión</h3>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
            <i class="bi-x modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></i>
         </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-8">
                    <div *ngIf="errorLogin" class="text-danger">
                        <div>{{errorMsg}}</div>                        
                    </div>
                    <form  [formGroup]="form" (ngSubmit)="onSubmit()" class="login mb-4">
                        <div class="form-control">
                            <p class="mb-1">Correo Electrónico</p>
                            <input type="email" class="w-100" formControlName="username">
                            <div *ngIf="submitted && f.username.errors" class="text-danger">
                                <div *ngIf="f.username.errors.required">Correo Electrónico es requerido.</div>
                                <div *ngIf="f.username.errors.email">La dirección de correo no es válida</div>
                            </div>
                        </div>
                        <div class="form-control">
                            <p class="mb-1">Contraseña</p>
                            <input type="password" name="" class="w-100" formControlName="password">
                            <div *ngIf="submitted && f.password.errors" class="text-danger">
                                <div *ngIf="f.password.errors.required">Contraseña es requerida.</div>                                
                            </div>
                        </div>
                        <div class=" text-center mt-4">
                            <button type="submit" class="align-self-center border-2 btn btn-lg btn-outline-primary btn-reservar rounded-pill text-center">Iniciar Sesión</button>
                        </div>
                    </form>
                    <p class="text-secondary text-center">¿No tenés cuenta?
                        <a [routerLink]="[rutaRegister]" (click)="openRegister()" class="text-bold text-decoration-none modal-link">Regístrate.</a>
                    </p>
                    <p class="text-secondary text-center">
                        <a [routerLink]="[rutaRecuperar]" (click)="openRecuperar()" class="text-bold text-decoration-none modal-link">Restaurar contraseña.</a>
                    </p>
                </div>
                 <div class="col-lg-2"></div>
            </div>
        </div>
        <div class="modal-footer border-0">
            <img src="assets/images/body/bg-login-2.svg" alt="">
        </div>
    </div>
</div>

